export default function Contact() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-navy mb-6">Contact VCA</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ready to join our boating community? Get in touch with us today.
          </p>
        </div>
        
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
          <p className="mb-2"><strong>Commodore:</strong> +27 83 446 9474</p>
          <p className="mb-2"><strong>Secretary:</strong> 016 004 0192</p>
          <p className="mb-2"><strong>Email:</strong> info@vaalcruising.co.za</p>
          <p className="mb-2"><strong>Location:</strong> Aloe Fjord, Vaal Dam, Gauteng</p>
        </div>
      </div>
    </section>
  );
}